import { Link, useLocation } from 'react-router-dom';
// import Req from "~/Utils/Req";
// import { Menu } from 'antd';
// import Companies, { CompanyIcon } from './Companies';

// import Style from "./index.css";
// import { useTheme } from '@mui/material';
// import Style from "./index.css";
import ReadMeData from "~/Data/ReadMe.json";
import type { TitleAndContent } from "~/Data/Types";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Container from '@mui/material/Container';
import HomeIcon from '@mui/icons-material/Home';
import { PrefixUri } from '~/Utils/Util';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {default as MuiLink} from '@mui/material/Link';
import { Helmet } from 'react-helmet-async';
import WrapMarkdown from '~/Components/WrapMarkdown';
import { useEffect } from 'react';
import NotFound from './NotFound';
// import { dark } from 'react-syntax-highlighter/dist/cjs/al'

interface BreadcrumbInfo {
    Title: string
    TitleId: string
    HasContent: boolean
    URI: string
}

export default () => {

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [pathname])

    const readMe: TitleAndContent[] = ReadMeData;

    let searchTarget: TitleAndContent = {
        Title: "",
        TitleId: "",
        Content: "",
        SubContents: readMe,
    }

    // let titleAndContent: TitleAndContent | null = searchTarget;

    const breadcrumbInfos: BreadcrumbInfo[] = [];
    const pathSplit = pathname.substring(1).split('/');
    let noResult: boolean = false;

    for (let index = 0; index < pathSplit.length; index++) {
        const pathFragment = pathSplit[index];

        let found: boolean = false;
        for (let searchSubIndex = 0; searchSubIndex < searchTarget.SubContents.length; searchSubIndex++) {
            const subResult = searchTarget.SubContents[searchSubIndex];
            if (subResult.TitleId === pathFragment) {
                breadcrumbInfos.push({
                    Title: subResult.Title,
                    TitleId: subResult.TitleId,
                    HasContent: subResult.Content !== "",
                    URI: "/" + PrefixUri(...breadcrumbInfos.map(({TitleId}) => TitleId), subResult.TitleId)
                })
                found = true;
                searchTarget = subResult;
                break;
            }
        }

        if (!found) {
            noResult = true;
            break;
        }
    }

    if (noResult) {
        return (<NotFound/>);
    }

    if(breadcrumbInfos[0].TitleId !== "") {
        breadcrumbInfos.unshift({
            Title: "",
            TitleId: "",
            HasContent: true,
            URI: "",
        })
    }

    return (<Container maxWidth="xl">
        <Helmet>
            <title>
                {searchTarget.Title === ''? 'SaintsField': `${searchTarget.Title} | SaintsField`}
            </title>
        </Helmet>

        <Box component={"main"}>
            <Breadcrumbs component={"nav"}>{breadcrumbInfos.map(({TitleId, Title, URI, HasContent}, index) => {
                if(TitleId === "") {
                    return <MuiLink key="" to="/" component={Link}><HomeIcon /></MuiLink>;
                }
                const isLast: boolean = index === breadcrumbInfos.length - 1;
                if(isLast || !HasContent) {
                    return <Typography key={TitleId} sx={{ color: isLast? 'text.primary': 'text.disabled', textDecoration: isLast? 'underline': undefined }}>
                        <WrapMarkdown disallowedElements={['p']} unwrapDisallowed>{Title}</WrapMarkdown>
                    </Typography>;
                }
                return <MuiLink key={TitleId} underline="hover" color="inherit" to={URI} component={Link}>
                    <WrapMarkdown disallowedElements={['p']} unwrapDisallowed>{Title}</WrapMarkdown>
                </MuiLink>;
            })}</Breadcrumbs>

            <article>
                <Typography variant="h3" gutterBottom sx={{wordBreak: 'break-all'}} component={"header"}>
                    <WrapMarkdown disallowedElements={['p']} unwrapDisallowed>{searchTarget.Title}</WrapMarkdown>
                </Typography>
                {searchTarget.Content !== "" && <WrapMarkdown>{searchTarget.Content}</WrapMarkdown>}
            </article>
        </Box>
    </Container>);

};
